// External Dependencies
import { useQueryClient } from '@tanstack/react-query';
import { CreateInvoicePaymentRequest } from '@presto-assistant/api_types/api/admin/invoicePayments';
import { useCallback } from 'react';

// Internal Dependencies
import { prestoAdminApiClient } from 'utils/api/apiClient';
import { useTanstackMutation } from 'utils/api/index';

export const useCreateInvoicePayment = () => {
  const queryClient = useQueryClient();

  const mutationFn = useCallback((payload: CreateInvoicePaymentRequest['body']) => {
    return prestoAdminApiClient.v1.invoicePayments.createInvoicePayment(payload);
  }, []);

  return useTanstackMutation({
    mutationFn,
    onSuccess: () => {
      // Clear invoice show from cache
      queryClient.invalidateQueries(['getInvoice']);

      // Clear invoice index from cache
      queryClient.invalidateQueries(['getAllInvoices']);

      // Clear estimate show from cache
      queryClient.invalidateQueries(['getEstimate']);

      // Clear estimate index from cache
      queryClient.invalidateQueries(['getAllEstimates']);
    },
  });
};
